"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@emotion/react");
exports.default = (0, react_1.css) `
    .rating__container {
        --rating-stars-free-space: 4px;
    }
`;
